import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class UnidadeMedidaService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getUnidadesMedida(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/unidadesmedida' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getUnidadeMedida(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/unidadesmedida/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaUnidadeMedida(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/unidadesmedida', {
				unidade_medida_nome: data.unidade_medida_nome,
				unidade_medida_codigo: data.unidade_medida_codigo,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaUnidadeMedida(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/unidadesmedida/' + data.unidade_medida_id, {
				unidade_medida_nome: data.unidade_medida_nome,
				unidade_medida_codigo: data.unidade_medida_codigo,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaUnidadeMedida(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/unidadesmedida/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
